import type { ExperienceListFilters } from 'actions/ExperienceActions'
import { fetchExperienceList } from 'actions/ExperienceActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useStableObjectReference from 'hooks/useStableObjectReference'
import { getExperienceListKey } from 'lib/experiences/experienceUtils'
import { useEffect, useMemo } from 'react'

type Filters = Omit<ExperienceListFilters, 'experienceIds'>

function useExperiences(experienceIds: Array<string> = [], filters: Filters = {}): [Array<App.ExperienceOffer>, boolean] {
  const dispatch = useAppDispatch()

  const stableExperienceIds = useStableObjectReference(experienceIds)

  const key = useMemo(() => getExperienceListKey({ ...filters, experienceIds: stableExperienceIds }), [filters, stableExperienceIds])

  useEffect(() => {
    if (stableExperienceIds.length) {
      dispatch(fetchExperienceList({ ...filters, experienceIds: stableExperienceIds }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stableExperienceIds, filters])

  const experience = useAppSelector(state => state.experience.experiences)
  const listFetching = useAppSelector(state => !!state.experience.experienceLists[key]?.fetching)

  const experiences = useMemo(() => stableExperienceIds.map(id => experience[id]).filter(Boolean), [experience, stableExperienceIds])

  return [experiences, listFetching]
}

export default useExperiences
